import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICmsScreenResponse } from '../../../entity/interface/iCmsScreen';
import { ICmsRepository } from '../../repositories/interfaces/iCmsRepository';

export interface IGetScreenUseCase {
    execute(screen: string): Promise<ICmsScreenResponse['data']>;
}

export class GetScreenUseCase implements IGetScreenUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get cmsRepository(): ICmsRepository {
        return container.resolve<ICmsRepository>(DI.REPOSITORIES.ICmsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(screen: string): Promise<ICmsScreenResponse['data']> {
        const response = await this.cmsRepository.getScreen(screen);
        return response.data;
    }
}
